export default "__VITE_ASSET__BQ4AryqD__"